import {Tab} from '@/components-v2/molecules/Tab/Tab'
import {TabsNavigation} from '@/components-v2/molecules/TabsNavigation.jsx/TabsNavigation'
import {useProductReview} from '../../context/ProductReviewContext'
import {BaseDataTab} from './BaseDataTab/BaseDataTab'
import {BrandAndCategoryTab} from './BrandAndCategoryTab/BrandAndCategoryTab'
import {DisplayTab} from './DisplayTab/DisplayTab'
import {MediaTab} from './MediaTab/MediaTab'
import {ProductReviewActions} from './ProductReviewActions'
import {TaxesAndSalesTab} from './TaxesAndSalesTab/TaxesAndSalesTab'

const PRODUCT_REVIEW_TABS = [
  {label: 'Base Data', component: BaseDataTab},
  {label: 'Media', component: MediaTab},
  {label: 'Display', component: DisplayTab},
  {label: 'Brand & Category', component: BrandAndCategoryTab},
  {label: 'Taxes & Sales', component: TaxesAndSalesTab},
]

export const ProductReviewTabs = () => {
  const {selectedTabIndex, setSelectedTabIndex} = useProductReview()
  const SelectedTabComponent = PRODUCT_REVIEW_TABS[selectedTabIndex]?.component ?? BaseDataTab

  return (
    <div>
      <div className="flex flex-col gap-6">
        <TabsNavigation selectedIndex={selectedTabIndex} onUpdate={setSelectedTabIndex}>
          {PRODUCT_REVIEW_TABS.map(({label}) => (
            <Tab key={label} label={label} />
          ))}
        </TabsNavigation>
        <SelectedTabComponent />
      </div>
      <ProductReviewActions />
    </div>
  )
}
